import { useUser } from '@/store/user'
import { IOrganization } from '@/types/organization'

export const useCurrentOrg = () =>
  useUser(state => state.currentOrganization) as IOrganization
